export default "__VITE_ASSET__BJ6JPfZ0__"